export default "__VITE_PUBLIC_ASSET__f41bb63e__"